/* AgentProfileCardWrapper.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk1bhr%7Bbackground-color%3Avar(--ds-surface-overlay%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1gwv%7Bwidth%3A360px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko1mok%7Bborder-radius%3Avar(--ds-radius-large%2C8px)%7D");
import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
const styles = {
  wrapper: "_2rko1mok _1bsb1gwv _bfhk1bhr"
};
export const AgentProfileCardWrapper = ({
  children
}: {
  children: React.ReactNode;
}): React.JSX.Element => {
  return <Box xcss={styles.wrapper}>{children}</Box>;
};